import {
    NgModule
} from '@angular/core';
import {
    Routes,
    RouterModule
} from '@angular/router';
const routes: Routes = [{
        path: '',
        redirectTo: 'launch',
        pathMatch: 'full'
    },
    {
        path: 'Screen1',
        loadChildren: () =>
            import ('./Screen1/Screen1.module').then(m => m.Screen1PageModule),
    },
    {
        path: 'screen3',
        loadChildren: () =>
            import ('./Screen3/Screen3.module').then(m => m.Screen3PageModule),
    },
    {
        path: 'screen4',
        loadChildren: () =>
            import ('./Screen4/Screen4.module').then(m => m.Screen4PageModule),
    },
    {
        path: 'screen2a',
        loadChildren: () =>
            import ('./Screen2A/Screen2A.module').then(m => m.Screen2APageModule),
    },
    {
        path: 'screen2b',
        loadChildren: () =>
            import ('./Screen2B/Screen2B.module').then(m => m.Screen2BPageModule),
    },
    {
        path: 'about_us1',
        loadChildren: () =>
            import ('./About_Us1/About_Us1.module').then(m => m.About_Us1PageModule),
    },
    {
        path: 'privacy_policy',
        loadChildren: () =>
            import ('./Privacy_Policy/Privacy_Policy.module').then(m => m.Privacy_PolicyPageModule),
    },
    {
        path: 'terms_of_service',
        loadChildren: () =>
            import ('./Terms_of_Service/Terms_of_Service.module').then(m => m.Terms_of_ServicePageModule),
    },
    {
        path: 'screen5',
        loadChildren: () =>
            import ('./Screen5/Screen5.module').then(m => m.Screen5PageModule),
    },
    {
        path: 'launch',
        loadChildren: () =>
            import ('./Launch/Launch.module').then(m => m.LaunchPageModule),
    },
];
@NgModule({
    imports: [RouterModule.forRoot(
        routes, {
            enableTracing: false,
            useHash: true
        }
    )],
    exports: [RouterModule]
})
export class AppRoutingModule {}